var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInlineImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.34315 3.34315 2 5 2H11C12.6569 2 14 3.34315 14 5V11C14 12.6569 12.6569 14 11 14H5C3.34315 14 2 12.6569 2 11V5Z",
    stroke: "#7D899D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29883 11.3004L3.23965 10.6284C3.90856 10.1506 4.82486 10.2264 5.40612 10.8077V10.8077C5.84392 11.2455 6.55374 11.2455 6.99154 10.8077L9.2365 8.56272C9.89479 7.90443 10.9464 7.85673 11.6616 8.45272L13.9988 10.4004",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.2,
    transform: "matrix(-1 0 0 1 5.59883 5.60039)",
    stroke: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInlineImage);
export default __webpack_public_path__ + "static/media/inlineImage.0199e70401fc0566357d9be386e939f3.svg";
export { ForwardRef as ReactComponent };